import { createSlice } from "@reduxjs/toolkit";
import { ProjectSliceItem } from "../../types/Applications";
import { ProjectList } from "../../data/applications/Project";

const initialState: ProjectSliceItem = {
  activeTab: "1",
  createdFormData: ProjectList,
};

const ProjectSlice = createSlice({
  name: "SideBarSlice",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setCreatedData: (state, action) => {
      state.createdFormData = action.payload;
    },
  },
});

export const { setActiveTab, setCreatedData } = ProjectSlice.actions;
export default ProjectSlice.reducer;
